module.exports = __webpack_public_path__ + "static/media/womanBicycle.9717750a.jpg";